// extracted by css-extract-rspack-plugin
export default {"menuList":"MailboxContentTableQuickFilters_menuList__xbvi2","menuItem":"MailboxContentTableQuickFilters_menuItem__6Rfw3"};